export const injectCssWithPrefixes = (element, styles) => {
  const prefixes = [`-webkit-`, `-moz-`, `-ms-`, `-o-`, ``]

  let css = ''
  styles.forEach(style => {
    const property = style[0]
    const value = style[1]

    prefixes.forEach(prefix => {
      css += `${prefix}${property}: ${value};`
    })
  })

  element.style = css
}

export const throttle = (fn, wait) => {
  let time = Date.now()
  return () => {
    if (time + wait - Date.now() < 0) {
      fn()
      time = Date.now()
    }
  }
}
